export const ILegalClientAssetRoleId = {
  Owner: 1,
} as const;

export type ILegalClientAssetRoleId =
  (typeof ILegalClientAssetRoleId)[keyof typeof ILegalClientAssetRoleId];
